var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"none"},attrs:{"src":"https://anmeldung.csn.de/dmb-rechtsschutz","width":"100%","height":"1930"}})}
var staticRenderFns = []

export { render, staticRenderFns }